<div class="flex flex-column">
  <h3 class="text-center" style="color: var(--secondary-color);"><span *ngIf="search" class="">"{{search}}" </span>No se encontraron productos.</h3>
</div>
